import { render, staticRenderFns } from "./certTarget.vue?vue&type=template&id=24ecf1fd&scoped=true&"
import script from "./certTarget.vue?vue&type=script&lang=js&"
export * from "./certTarget.vue?vue&type=script&lang=js&"
import style0 from "./certTarget.vue?vue&type=style&index=0&id=24ecf1fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ecf1fd",
  null
  
)

export default component.exports